/*=========================================================================================
  File Name: store.js
  Description: Vuex store
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'

export default new Vuex.Store({
  plugins: [createPersistedState()],
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth
  },
  strict: process.env.NODE_ENV !== 'production'
})
